import React from 'react';
import {map} from 'lodash';
import InvitedUser from './invited-user';
import EmojiPeople from 'src/components/AccountSettings/EmojiPeople';
import EarnedReferralSection from './earned-referral-section';
export const MAX_INVITES = 10;

interface Props {
  invitations: {display: string; status: string; name?: string; image?: string}[];
  awardAmount: number;
}

const SentInvitations = ({invitations, awardAmount}: Props) => (
  <div
    className="nav-bar-invite-list"
    id="nav-bar-refer-panel-1"
    aria-labelledby="nav-bar-refer-tab-0"
  >
    <div className="emoji-people-and-earned-referral-section">
      <EmojiPeople />
      <EarnedReferralSection awardAmount={awardAmount} />
    </div>
    <div className="nav-bar-invite-list-invitations">
      {map(invitations, (invitation) => (
        <InvitedUser key={invitation.display} {...invitation} />
      ))}
    </div>
  </div>
);

export default SentInvitations;
